import { render, staticRenderFns } from "./KullaniciFormResultDataView.vue?vue&type=template&id=7c5505df&scoped=true"
import script from "./KullaniciFormResultDataView.vue?vue&type=script&lang=js"
export * from "./KullaniciFormResultDataView.vue?vue&type=script&lang=js"
import style0 from "./KullaniciFormResultDataView.vue?vue&type=style&index=0&id=7c5505df&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c5505df",
  null
  
)

export default component.exports